import { Link } from "react-router-dom";
import styles from '../Datagrid.module.scss';

export const detailsRender = (params: any, route: string) => {
    return <Link to={`/${route}/${params.id}`} className={styles.Link}>{params.value}</Link>
}
